import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':tenantId/photo-attachment',
    loadChildren: () => import('./features/photo-attachment/routes').then(m => m.PHOTO_ATTACHMENT_ROUTES)
  }
];
